

























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import elTable from "@/components/elTable.vue";
import { pulicInspectionInterface } from "@/store/function";
import { AppModule } from "@/store/modules/app";

@Component({
  name: "inspeAccountList",
  components: {
    "v-elTable": elTable
  }
})
export default class extends Vue {
  @Prop()
  private styleList: any;

  @Watch("styleList", { immediate: true, deep: true })
  onStylelist(val: any, oldVal: any) {
    if (val != null) {
      console.log(val);
      this.inspeHeight = val.height;
      this.inspeWidth = val.width;
      this.inspeLeft = val.left;
      this.inspeTop = val.top;
      this.inspeRight = val.right;
      this.inspeId = val.id;
      this.$nextTick(() => {
        (this as any).$refs.inspeAccountList.style.zIndex = val.zIndex;
      });
    }
  }
  private inspeHeight: string = "";
  private inspeWidth: string = "";
  private inspeLeft: string = "";
  private inspeTop: string = "";
  private inspeRight: string = "";
  private inspeId: number = 0;
  private eventList: any[] = [];
  private titleList: any[] = [
    {
      name: "全部",
      id: 0
    }
  ];
  private departmentList: any[] = [{ name: "23124", id: 0 }];
  private personnelId: number = 0;
  private closeInspe() {
    this.$emit("closeInspe");
  }

  private personnelList(id: number) {
    this.personnelId = id;
    this.aPictureInspeList("", "", "", "");
  }
  private handleShow() {
    AppModule.changeCommunicationDialogVisible(true);
  }
  private pageChange(page: number) {
    this.aPictureInspeList("", "", page, "");
  }
  private aPictureInspeList(
    start_time: string,
    end_time: string,
    page: any,
    id: any
  ) {
    let data: any = pulicInspectionInterface(start_time, end_time, page, id);
    data
      .then((v: any) => {
        this.eventList = v.data.eventList;
        this.departmentList = v.data.userList;
      })
      .catch((error: any) => {});
  }

  private mounted() {
    this.aPictureInspeList("", "", "", "");
  }
}
